import { AxiosPromise, AxiosStatic } from "axios";
import { ClientReallocation } from "../types/ClientReallocation";

export const findReallocationById =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (reallocationId: string): AxiosPromise<ClientReallocation> =>
    await appAxios.get(`${serverURL}/reallocations/${reallocationId}`, {
      withCredentials: true,
    });
